import {useInView} from "react-intersection-observer";

import estructionsMockup from "../../img/mockups/nyeveier-mockup-blur.png";

import threejsLogo from "../../img/logos/threejs.png";
import figmaLogo from "../../img/logos/figma.png";
import tailwindLogo from "../../img/logos/tailwind.png";
import reactLogo from "../../img/logos/react.png";
import nyeVeierLogo from "../../img/mockups/logo-color.png";
import mapboxLogo from "../../img/logos/Mapbox.png";
import typesScriptLogo from "../../img/logos/Typescript.png";

export default function Nyeveier() {
	const programs = [
		{link: "", name: "React", image: reactLogo},
		{link: "", name: "TypeScript", image: typesScriptLogo},
		{link: "", name: "Three.js", image: threejsLogo},
		{link: "", name: "Tailwind", image: tailwindLogo},
		{link: "", name: "Mapbox", image: mapboxLogo},
	];

	const goToPage = () => {
		return () => {
			window.open("https://nyeveier.no"); // Redirect to the specified link
		};
	};

	const {ref: program, inView: programVisible} = useInView();
	const {cont, inView: contVisible} = useInView();

	return (
		<div ref={cont} className={` h-auto pt-10 pb-12 flex flex-col items-center `}>
			<div
				onClick={goToPage()}
				className=" max-w-[920px] w-[75vw] min-h-[70vh] p-10 rounded-3xl border-2  border-[#00969D] transition-all duration-300 cursor-pointer hover:bg-neutral-800">
				<img className=" w-auto m-auto max-h-[50px]" src={nyeVeierLogo} />

				<img className=" m-auto max-h-[30vh] object-contain sm:-mt-4 mt-0 " src={estructionsMockup} />
				<p className="text-white lg:text-xl lg:font-light text-center md:text-left font-light text-sm leading-4 sm:mt-0 mt-4 ">
					For my bachelor thesis, my two classmates and I developed software for Nye Veier, which is now used daily by their employees. Our focus was
					on creating a modern visual system tailored to the organization’s requirements. The system incorporates navigational 360-degree photos,
					images, maps, and 3D visualization elements.
				</p>
				<h3 className="text-neutral-500 text-center text-xl mt-5">Tools</h3>

				<div ref={program} className=" mt-2 m-auto flex gap-4 justify-center flex-wrap">
					{programs.map((program, index) => (
						<div
							style={{animationDelay: `${0.05 * (index + 1)}s`}}
							className={`${
								programVisible ? "slide-in" : ""
							} opacity-0 relative h-14 w-14 md:h-24 md:w-24 p-2 md:rounded-3xl rounded-lg  flex flex-col gap-2 justify-center transition-all duration-200 bg-neutral-700 bg-opacity-25`}>
							<img className=" object-scale-down h-6 sm:h-12 hover:grayscale-0" src={program.image} alt={program.name} />
							<h4 className="text-center text-neutral-200 font-medium text-xss md:text-sm -mt-2 ">{program.name}</h4>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
